import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getHistoryTimelineItem } from "core/http/service/personnelInformation/resTypes";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: getHistoryTimelineItem[];
  activeId: string;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: [],
  activeId: undefined,
};

const getHistoryTimelineSlice = createSlice({
  name: "getHistoryTimeline",
  initialState,
  reducers: {
    getHistoryTimelineStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getHistoryTimelineSuccess: (
      state,
      action: PayloadAction<getHistoryTimelineItem[]>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getHistoryTimelineFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    setHistoryTimelineActiveId: (state, action: PayloadAction<string>) => {
      state.activeId = action.payload;
    },
    resetHistoryTimeline: () => {
      return { ...initialState };
    },
  },
});

export const {
  getHistoryTimelineStart,
  getHistoryTimelineSuccess,
  getHistoryTimelineFailed,
  setHistoryTimelineActiveId,
  resetHistoryTimeline,
} = getHistoryTimelineSlice.actions;

export default getHistoryTimelineSlice.reducer;
